import classnames from "classnames";
import styles from "@/styles/NoContentMessage.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function NoContentMessage(_ref) {
  var className = _ref.className,
      message = _ref.message,
      children = _ref.children;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.container, className),
    children: [message && /*#__PURE__*/_jsx("p", {
      className: styles.message,
      children: message
    }), children && /*#__PURE__*/_jsx(_Fragment, {
      children: children
    })]
  });
}